<script>
  import { navigate } from 'svelte-routing';
  import { getApiUrl } from '../api';
  import { authStore } from '../authStore';
  import { authFetch } from '../authService';

  let title = '';
  let body = '';
  let isSubmitting = false;
  let currentUser;
  authStore.subscribe(v => currentUser = v.user);

  async function handleSubmit() {
      if(!confirm("This will deduct 10 credits. Continue?")) return;
      isSubmitting = true;
      try {
          const res = await authFetch(getApiUrl('/qa/questions'), {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({ userId: currentUser.idTokenClaims.oid, title, body })
          });
          if(res.ok) navigate('/qa/list');
          else {
              const d = await res.json();
              alert(d.error || "Failed");
          }
      } catch(e) { console.error(e); }
      finally { isSubmitting = false; }
  }
</script>

<div class="container">
    <h2>Ask a Question</h2>
    <form on:submit|preventDefault={handleSubmit}>
        <label>Title</label>
        <input type="text" bind:value={title} required placeholder="e.g. Best credit card for dining?" />
        
        <label>Details</label>
        <textarea bind:value={body} rows="5" required></textarea>
        
        <button disabled={isSubmitting}>{isSubmitting ? 'Posting...' : 'Post Question (10 Credits)'}</button>
    </form>
</div>
<style>
    .container { max-width: 600px; margin: 2rem auto; padding: 2rem; background: white; border-radius: 8px; }
    input, textarea { width: 100%; padding: 0.75rem; margin-bottom: 1rem; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box;}
    button { background: #28a745; color: white; border: none; padding: 1rem; width: 100%; border-radius: 4px; font-size: 1rem; cursor: pointer; }
    label { display: block; margin-bottom: 0.5rem; font-weight: bold; }
</style>